export var EPaymentConstant = /*#__PURE__*/function (EPaymentConstant) {
  EPaymentConstant[EPaymentConstant["KopeikiPerRuble"] = 100] = "KopeikiPerRuble";
  return EPaymentConstant;
}({});
export var SMS_CODE_MODAL = 'sms';
export var EPaymentMethod = /*#__PURE__*/function (EPaymentMethod) {
  EPaymentMethod["SBP"] = "fps";
  EPaymentMethod["Card"] = "card";
  EPaymentMethod["SberPay"] = "sberpay";
  EPaymentMethod["SavedCard"] = "savedCards";
  return EPaymentMethod;
}({});
export var EPaymentMethodGranular = /*#__PURE__*/function (EPaymentMethodGranular) {
  EPaymentMethodGranular["SBP"] = "sbp";
  EPaymentMethodGranular["Card"] = "newCard";
  EPaymentMethodGranular["SberPay"] = "sberPay";
  EPaymentMethodGranular["SavedCard"] = "boundCards";
  EPaymentMethodGranular["SberPayBinding"] = "sberPayBinding";
  EPaymentMethodGranular["SBPBinding"] = "sbpBinding";
  return EPaymentMethodGranular;
}({});
export var EArea = /*#__PURE__*/function (EArea) {
  EArea["Authorized"] = "AZ";
  EArea["Unauthorized"] = "NZ";
  EArea["AccountDashboard"] = "ELK";
  return EArea;
}({});